// Client-side filter: buttons [data-filter-value] show only the [data-filter-item] elements whose
// space-separated list contains the value ("" = all).
// Several groups (Referenzen listing): the buttons of each group sit in an element with
// data-filter-group="<name>", an item lists its values per group in data-filter-<name>, and it shows when
// every group matches. An element [data-filter-count] gets the number of shown items through its
// data-filter-text ("{n}" is replaced; data-filter-text-one for exactly one).
export function initFilters() {
	document.querySelectorAll('[data-filter]').forEach((root) => {
		const buttons = [...root.querySelectorAll('[data-filter-value]')]
		const items = [...root.querySelectorAll('[data-filter-item]')]
		const count = root.querySelector('[data-filter-count]')
		const active = {}
		const groupOf = (button) => button.closest('[data-filter-group]')?.dataset.filterGroup ?? ''
		const valuesOf = (item, group) => (group ? item.dataset['filter' + group[0].toUpperCase() + group.slice(1)] : item.dataset.filterItem) ?? ''

		const update = () => {
			let shown = 0
			items.forEach((item) => {
				const match = Object.entries(active).every(([group, value]) => value === '' || valuesOf(item, group).split(' ').includes(value))
				item.hidden = !match
				if (match) shown++
			})
			if (count) {
				const text = shown === 1 && count.dataset.filterTextOne ? count.dataset.filterTextOne : count.dataset.filterText
				count.textContent = text.replace('{n}', shown)
			}
		}

		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				const group = groupOf(button)
				active[group] = button.dataset.filterValue
				buttons.filter((b) => groupOf(b) === group).forEach((b) => b.setAttribute('aria-pressed', String(b === button)))
				update()
			})
		})
	})
}
